import React, { useEffect } from "react";
import Hero from "../components/home/Hero";
import ServicesOverview from "../components/home/ServicesOverview";
import AboutPreview from "../components/home/AboutPreview";
import Testimonials from "../components/home/Testimonials";
import ContactCTA from "../components/home/ContactCTA";

const HomePage = () => {
  useEffect(() => {
    document.title =
      "Professional Service Associates | Tax & Business Consultancy";
  }, []);

  return (
    <>
      <Hero />
      <ServicesOverview />
      <AboutPreview />
      <Testimonials />
      <ContactCTA />
    </>
  );
};

export default HomePage;
